/**
 * Elevate desktop mega menu
 * - Hover OR click opens the panel
 * - Panel is ported to document.body so it is never clipped / never loses hover
 * - "Shop" click toggles the menu (does not navigate away); use in-panel "Shop all"
 * - Panel is clamped to the viewport so left-nav Shop stays fully on-screen
 */
(function () {
  'use strict';

  var MQ = '(min-width: 990px)';
  var OPEN = null; // { dd, panel, link, placeholder }
  var lastDesktop = null;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function isDesktop() {
    try {
      return window.matchMedia(MQ).matches;
    } catch (e) {
      return window.innerWidth >= 990;
    }
  }

  function place(panel, link) {
    if (!panel || !link) return;
    var r = link.getBoundingClientRect();
    var pad = 12;
    var top = Math.round(r.bottom + 10);
    var maxH = Math.max(160, window.innerHeight - top - pad);
    var maxW = Math.max(240, window.innerWidth - pad * 2);

    panel.style.position = 'fixed';
    panel.style.top = top + 'px';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
    panel.style.transform = 'none';
    panel.style.zIndex = '2147483646';
    panel.style.opacity = '1';
    panel.style.visibility = 'visible';
    panel.style.pointerEvents = 'auto';
    panel.style.display = 'block';
    panel.style.maxHeight = maxH + 'px';
    panel.style.maxWidth = maxW + 'px';
    panel.style.overflow = 'auto';

    var pw = panel.getBoundingClientRect().width || Math.min(506, maxW);
    var preferred = Math.round(r.left);
    var maxLeft = window.innerWidth - pw - pad;
    var left = Math.max(pad, Math.min(preferred, maxLeft));
    panel.style.left = left + 'px';
  }

  function close() {
    if (!OPEN) return;
    var o = OPEN;
    OPEN = null;
    o.dd.classList.remove('is-open');
    o.link.setAttribute('aria-expanded', 'false');
    o.panel.removeAttribute('data-open');
    o.panel.classList.remove('elevate-nav__panel--ported');
    if (o.placeholder && o.placeholder.parentNode) {
      o.placeholder.parentNode.insertBefore(o.panel, o.placeholder);
      o.placeholder.parentNode.removeChild(o.placeholder);
    }
    o.panel.removeAttribute('style');
    document.documentElement.classList.remove('elevate-nav-mega-open');
  }

  function closeMobileDrawer() {
    var host = document.querySelector('header-drawer');
    if (!host) return;
    var details = host.querySelector('details[open]');
    if (!details) return;
    var summary = details.querySelector('summary');
    if (summary && typeof host.closeMenuDrawer === 'function') {
      host.closeMenuDrawer({ type: 'resize' }, summary);
    }
  }

  function open(dd) {
    if (!isDesktop()) return;
    var link = dd.querySelector('.elevate-nav__summary-link');
    var panel = dd.querySelector('.elevate-nav__panel');
    if (!link || !panel) return;

    if (OPEN && OPEN.dd === dd) {
      place(OPEN.panel, OPEN.link);
      return;
    }
    if (OPEN) close();

    var placeholder = document.createComment('elevate-nav-panel');
    panel.parentNode.insertBefore(placeholder, panel);
    document.body.appendChild(panel);
    panel.classList.add('elevate-nav__panel--ported');
    panel.setAttribute('data-open', 'true');
    dd.classList.add('is-open');
    link.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('elevate-nav-mega-open');
    place(panel, link);
    requestAnimationFrame(function () {
      if (OPEN && OPEN.dd === dd) place(OPEN.panel, OPEN.link);
    });

    OPEN = { dd: dd, panel: panel, link: link, placeholder: placeholder };
  }

  function toggle(dd) {
    if (OPEN && OPEN.dd === dd) close();
    else open(dd);
  }

  ready(function () {
    lastDesktop = isDesktop();
    var dropdowns = document.querySelectorAll('[data-elevate-nav-dropdown]');
    if (!dropdowns.length) return;

    dropdowns.forEach(function (dd) {
      var link = dd.querySelector('.elevate-nav__summary-link');
      var panel = dd.querySelector('.elevate-nav__panel');
      if (!link || !panel) return;

      var href = (link.getAttribute('href') || '').replace(/\/$/, '');
      if (!href || href === '#' || href === '/') {
        link.setAttribute('href', '/collections');
      }
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('role', 'button');

      var leaveTimer = null;
      function cancelLeave() {
        if (leaveTimer) {
          clearTimeout(leaveTimer);
          leaveTimer = null;
        }
      }
      function scheduleClose() {
        cancelLeave();
        leaveTimer = setTimeout(function () {
          if (OPEN && OPEN.dd === dd) {
            var over =
              dd.matches(':hover') ||
              (OPEN.panel && OPEN.panel.matches(':hover'));
            if (!over) close();
          }
        }, 220);
      }

      dd.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        cancelLeave();
        open(dd);
      });
      dd.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        scheduleClose();
      });

      panel.addEventListener('mouseenter', function () {
        cancelLeave();
      });
      panel.addEventListener('mouseleave', function () {
        scheduleClose();
      });

      link.addEventListener('click', function (e) {
        if (!isDesktop()) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        toggle(dd);
      });

      link.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          close();
          link.focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          if (!isDesktop()) return;
          e.preventDefault();
          toggle(dd);
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!OPEN) return;
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-elevate-nav-dropdown]') || t.closest('.elevate-nav__panel--ported')) return;
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    window.addEventListener(
      'scroll',
      function () {
        if (OPEN) place(OPEN.panel, OPEN.link);
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      var desktop = isDesktop();
      if (desktop !== lastDesktop) {
        close();
        if (desktop) closeMobileDrawer();
        lastDesktop = desktop;
        return;
      }
      if (!desktop) close();
      else if (OPEN) place(OPEN.panel, OPEN.link);
    });
  });
})();
